export const customScrollBarSettings = {
	/* Firefox */
	scrollbarWidth: 'thin',
	scrollbarColor: '#A6A6A6 transparent',
	/* WebKit */
	'&::-webkit-scrollbar': {
		width: '4px',
		height: '4px'
	},
	'&::-webkit-scrollbar-track': { background: 'transparent' },
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: '#A6A6A6',
		borderRadius: '4px'
	},
	scrollbarGutter: 'stable'
}
